import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export interface IDisclaimerProps {
  testId: string;
  header: string;
  title: string;
}

export const Disclaimer: React.FC<IDisclaimerProps> = ({ testId, header, title }) => {
  return (
    <div data-testid={testId} className={style['item']}>
      <UIHeading4>{header}</UIHeading4>
      <UIText2>{title}</UIText2>
    </div>
  );
};
